export default __webpack_public_path__ + "static/media/img_company_header9.1c946d98.png";